(() => {
  function setup(root) {
    if (root.dataset.mobilePurchaseReady === 'true') return;
    root.dataset.mobilePurchaseReady = 'true';

    const form = root.querySelector('form');
    const variantInput = root.querySelector('[data-mobile-purchase-variant]');
    if (!form || !variantInput) return;

    form.addEventListener('submit', () => {
      const variantId = new URL(window.location.href).searchParams.get('variant');
      if (variantId) variantInput.value = variantId;
    });
  }

  document.querySelectorAll('[data-mobile-purchase]').forEach(setup);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-mobile-purchase]').forEach(setup);
  });
})();
